export default "__VITE_ASSET__CYChUva0__"